import React, { useState, useEffect } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Pagination, PaginationItem, TablePagination, TextField, InputAdornment, Button } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import FilterIcon from '../../assets/images/filter.png'
import Download from '../../assets/images/download.png'
import Maximize from '../../assets/images/maximize-2.png'
import Grid from '../../assets/images/grid.png'
import { Box, Typography } from "@mui/material";
import ApplicantDetail, { ApplicantData } from '../verifier/applicantDetail';
import swal from 'sweetalert';
import { getfieldstaffsignupdetails, verifierStatusUpdate } from '../../Models/model';
import { downloadExcel } from 'react-export-table-to-excel';
import moment from 'moment'
import CustomDialogue from '../../components/helpers/CustomDialogue';

type GridRow = {
    id: number;
    submittedDate?: string;
    FullName?: string;
    gender?: string | null;
    fieldstaffPrimaryMobile?: string;
    fieldstaffAlternativeMobile?: string;
    fieldStaffPrimaryEmail?: string;
    fieldStaffAlternativeEmail?: string;
    userAddressdet?: { country?: string }[];
    currentStatus?: string;
};

function Verifier() {
    const primaryColor = "#1A3353";
    const [selected, setSelected] = useState<string>("All");
    const [_requestDataCount, _setRequestdataCount] = useState<number>(0);
    const [_page, _setPage] = useState(1);
    const [_rowsPerPage, _setRowsPerPage] = useState(10);

    const [view, setView] = useState<"grid" | "detail">("grid");
    const [selectedCustomerId, setSelectedCustomerId] = useState<string | null>(null);
    const [applicantDetail, setApplicantDetail] = useState<ApplicantData | null>(null);
    const [detailLoading, setDetailLoading] = useState(false);

    const [rows, setRows] = useState<GridRow[]>([]);
    const [gridLoading, setGridLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [_verifierFullscreenFlag, _setVerifierFullscreenFlag] = useState(false)


    const mapFieldStaffToApplicantData = (raw: any): ApplicantData => {
        const address = raw?.userAddressdet?.[0] || {};
        const educationList = raw?.userEducationdet || [];
        const firstEducation = educationList[0] || {};

        const allEducationDocs: string[] = educationList
            .flatMap((edu: any) => edu?.userEducationdocdet || [])
            .map((doc: any) => doc?.documentUrl)
            .filter(Boolean);

        // const allEducationDocs: string[] = Array.from(
        //     new Set(
        //         (firstEducation.userEducationdocdet || [])
        //             .map((doc: any) => doc?.documentUrl)
        //             .filter(Boolean)
        //     )
        // );

        const splitLang = (val: string | null | undefined) =>
            val ? val.split(',').map((s) => s.trim()).filter(Boolean) : [];

        const formatDate = (val: string | null | undefined) => {
            if (!val) return '';
            const d = new Date(val);
            if (isNaN(d.getTime())) return val;
            return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
        };

        const fileNameFromUrl = (url: string | null | undefined) => {
            if (!url) return '';
            try {
                return decodeURIComponent(url.split('/').pop() || url);
            } catch {
                return url;
            }
        };

        return {
            currentStatus: raw?.currentStatus || raw?.CurrentStatus || '',

            referrals: {
                status: '',
                codeUsed: '',
                referredBy: '',
                date: '',
            },
            basicProfile: {
                fullName: raw?.FullName || '',
                mobileNo: raw?.fieldstaffPrimaryMobile || '',
                email: raw?.fieldStaffPrimaryEmail || '',
                dob: formatDate(raw?.dob),
                gender: raw?.gender || '',
                languagesRead: splitLang(raw?.readLanguage),
                languagesWrite: splitLang(raw?.writeLanguage),
            },
            address: {
                addressLine1: address.addressLine1 || '',
                addressLine2: address.addressLine2 || address.addressLine1 || '',
                country: address.country || '',
                state: address.state || '',
                district: address.city || '',
                pincode: address.postalCode || '',
            },
            selfieUrl: raw?.selfieurl || raw?.profilePicUrl || '',
            contact: {
                primaryMobile: raw?.fieldstaffPrimaryMobile || '',
                primaryEmail: raw?.fieldStaffPrimaryEmail || '',
                altMobile: raw?.fieldstaffAlternativeMobile || '',
                altEmail: raw?.fieldStaffAlternativeEmail || '',
            },
            education: {
                highestQualification: firstEducation.highestQualification || '',
                schoolName: firstEducation.schoolName || '',
                boardName: firstEducation.boardName || '',
                yearOfCompletion: firstEducation.yearofCompletion?.toString() || '',
                documents: allEducationDocs,
            },
            twoWheeler: {
                vehicleRegNo: raw?.isTwowheelerAvailable === 'Yes' ? (raw?.vechichleNumber || '') : '',
                rcBookFileName: fileNameFromUrl(raw?.rcphotoUrl),
                rcBookFileUrl: raw?.rcphotoUrl || '',
            },
            experience: {
                hasExperience: raw?.previousExperience || '',
                organizationName: raw?.organaizationName || '',
                yearsOfExperience: raw?.yearsofExperience ? `${raw.yearsofExperience} years` : '',
            },
            documents: {
                panCard: raw?.panNumber || '',
                panFileName: fileNameFromUrl(raw?.panUrl),
                panFileUrl: raw?.panUrl || '',
                drivingLicense: raw?.dlnumber || '',
                expiryDate: formatDate(raw?.dlexpiryDate),
                frontSideFileName: fileNameFromUrl(raw?.dlfrontUrl),
                frontSideFileUrl: raw?.dlfrontUrl || '',
                backSideFileName: fileNameFromUrl(raw?.dlBackUrl),
                backSideFileUrl: raw?.dlBackUrl || '',
            },
        };
    };

    const exportVerifierEXCEL = () => {
        const header: string[] = ["S.No", "Submitted Date", "Full Name", "Gender", "Mobile No", "Email Address", "Country"];

        const body = filteredRows.map((item: GridRow, index: number) => {
            return [
                index + 1,
                item?.submittedDate || "-",
                item?.FullName || "-",
                item?.gender || "-",
                item?.fieldstaffAlternativeMobile || "-",
                item?.fieldStaffPrimaryEmail || "-",
                item?.userAddressdet?.[0]?.country || "-",
            ];
        });

        const curDate = moment()?.format("YYYY-MM-DD");
        const filename = "Verifier_" + curDate;

        downloadExcel({
            fileName: filename,
            sheet: "Verifier",
            tablePayload: {
                header,
                body,
            },
        });
    };

    const getLoggedInUsername = () => {
        return localStorage.getItem('username') || '';
    };

    const updateVerifierStatus = async (
        status: number | null,
        currentStatus: string,
        comment: string
    ) => {
        if (!selectedCustomerId) return;
        try {
            const response = await verifierStatusUpdate({
                userId: Number(selectedCustomerId),
                status,
                currentStatus,
                comment,
                createdBy: getLoggedInUsername(),
            });
            if (response?.data?.status === "Success") {
                swal(`Applicant marked as ${currentStatus}`, { icon: 'success' });
            } else {
                swal(response?.data?.data || "Something went wrong updating status", { icon: 'warning' });
            }
        } catch (error) {
            console.log(error);
            swal("Something went wrong updating status", { icon: 'error' });
        } finally {
            handleBackToGrid();
        }
    };

    const fetchGridData = () => {
        setGridLoading(true);
        getfieldstaffsignupdetails(0)
            .then((response: any) => {
                if (response?.data?.status === "Success") {
                    const list = response?.data?.data || [];
                    setRows(list);
                    _setRequestdataCount(list.length);
                } else {
                    swal(response?.data?.data || "Failed to load list", { icon: 'warning' });
                }
            })
            .catch((error: any) => {
                console.log(error);
                swal("Something went wrong loading the grid", { icon: 'error' });
            })
            .finally(() => setGridLoading(false));
    };

    const handleSearchChange = (value: string) => {
        setSearchQuery(value);
        _setPage(1);
    };

    useEffect(() => {
        fetchGridData();
    }, []);

    const handleClick = (value: string) => {
        setSelected(value);
        _setPage(1);
    };

    const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
        _setPage(newPage + 1);
    };

    const handleChangePage1 = (event: React.ChangeEvent<unknown>, value: number) => {
        _setPage(value);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        _setRowsPerPage(newRowsPerPage);
        _setPage(1);
    };

    const handleViewClick = async (row: GridRow) => {
        setSelectedCustomerId(String(row.id));
        setDetailLoading(true);
        try {
            const response = await getfieldstaffsignupdetails(row.id);
            const record = response?.data?.data?.[0];
            if (!record) {
                swal("No signup details found for this user", { icon: 'warning' });
                setDetailLoading(false);
                return;
            }
            const mapped = mapFieldStaffToApplicantData(record);
            setApplicantDetail(mapped);
            setView("detail");
        } catch (error) {
            console.log(error);
            swal("Something went wrong fetching applicant details", { icon: 'error' });
        } finally {
            setDetailLoading(false);
        }
    };

    const handleBackToGrid = () => {
        setView("grid");
        setSelectedCustomerId(null);
        setApplicantDetail(null);
        fetchGridData();
    };

    const handleApprove = (reason: string) => {
        updateVerifierStatus(2, 'Approved', reason);
    };

    const handleReject = (reason: string) => {
        updateVerifierStatus(3, 'Rejected', reason);
    };

    const handleHold = (reason: string) => {
        updateVerifierStatus(4, 'Hold', reason);
    };

    const TAB_TO_STATUS: Record<string, string> = {
        New: 'Submitted',
        Accepted: 'Approved',
        Rejected: 'Rejected',
        'On-Hold': 'Hold',
        Resubmitted: 'Resubmitted',
    };

    const filteredRows = rows.filter((row) => {
        const matchesTab = selected === 'All' || row.currentStatus === TAB_TO_STATUS[selected];

        if (!matchesTab) return false;
        if (!searchQuery) return true;
        const q = searchQuery.toLowerCase();
        return (
            String(row.id).toLowerCase().includes(q) ||
            row.FullName?.toLowerCase().includes(q) ||
            row.fieldstaffPrimaryMobile?.toLowerCase().includes(q) ||
            row.fieldStaffPrimaryEmail?.toLowerCase().includes(q) ||
            row.userAddressdet?.[0]?.country?.toLowerCase().includes(q)
        );
    });

    const totalCount = filteredRows.length;

    const paginatedRows = filteredRows.slice(
        (_page - 1) * _rowsPerPage,
        (_page - 1) * _rowsPerPage + _rowsPerPage
    );

    if (view === "detail" && applicantDetail) {
        return (
            <ApplicantDetail
                applicant={applicantDetail}
                onBack={handleBackToGrid}
                onApprove={handleApprove}
                onReject={handleReject}
                onHold={handleHold}
            />
        );
    }

    const getVerifierTableComponent = () => {
        return (
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ whiteSpace: "nowrap", color: "#353535", fontWeight: "700" }} align="center">S.No</TableCell>
                            <TableCell sx={{ whiteSpace: "nowrap", color: "#353535", fontWeight: "700" }} align="center">Submitted Date</TableCell>
                            <TableCell sx={{ whiteSpace: "nowrap", color: "#353535", fontWeight: "700" }} align="center">Action</TableCell>
                            <TableCell sx={{ whiteSpace: "nowrap", color: "#353535", fontWeight: "700" }} align="center">Customer ID</TableCell>
                            <TableCell sx={{ whiteSpace: "nowrap", color: "#353535", fontWeight: "700" }} align="center">Full Name</TableCell>
                            <TableCell sx={{ whiteSpace: "nowrap", color: "#353535", fontWeight: "700" }} align="center">Gender</TableCell>
                            <TableCell sx={{ whiteSpace: "nowrap", color: "#353535", fontWeight: "700" }} align="center">Mobile No</TableCell>
                            <TableCell sx={{ whiteSpace: "nowrap", color: "#353535", fontWeight: "700" }} align="center">Email Address</TableCell>
                            <TableCell sx={{ whiteSpace: "nowrap", color: "#353535", fontWeight: "700" }} align="center">Country</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {gridLoading ? (
                            <TableRow>
                                <TableCell align="center" colSpan={9}>Loading...</TableCell>
                            </TableRow>
                        ) : filteredRows.length ? (
                            paginatedRows.map((row, index) => (
                                <TableRow key={row.id}>
                                    <TableCell sx={{ whiteSpace: "nowrap" }} align="center">
                                        {String((_page - 1) * _rowsPerPage + index + 1).padStart(2, '0')}
                                    </TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap" }} align="center">{row.submittedDate || ''}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap" }} align="center">
                                        <Typography
                                            sx={{ cursor: "pointer", textDecoration: "underline" }}
                                            onClick={() => handleViewClick(row)}
                                        >
                                            {detailLoading && selectedCustomerId === String(row.id) ? "Loading..." : "View"}
                                        </Typography>
                                    </TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap" }} align="center">{row.id}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap" }} align="center">{row.FullName || ''}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap" }} align="center">{row.gender || ''}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap" }} align="center">{row.fieldstaffAlternativeMobile || ''}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap" }} align="center">{row.fieldStaffPrimaryEmail || ''}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap" }} align="center">{row.userAddressdet?.[0]?.country || ''}</TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell align="center" colSpan={9}>Data Not Found</TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        );
    };

    return (<>
        <div className="d-flex align-items-center text-white p-3">
            <h5 className="mb-0" style={{ color: "#000", fontWeight: "800" }}> </h5>
        </div>
        <div style={{ paddingLeft: 18, paddingTop: 10 }}>
            <Box display="flex" gap={4} sx={{ borderBottom: "1px solid #e0e0e0", width: "100%" }}>
                {["All", "New", "Accepted", "Rejected", "On-Hold"].map((option) => (
                    <Typography
                        key={option}
                        onClick={() => handleClick(option)}
                        sx={{
                            cursor: "pointer",
                            paddingBottom: "10px",
                            position: "relative",
                            color: selected === option ? "#000" : "#9a9da3",
                            fontWeight: selected === option ? 600 : 400,
                            "&::after": selected === option
                                ? { content: '""', position: "absolute", bottom: "-1px", left: 0, width: "100%", height: "2px", backgroundColor: "#ff3b30" }
                                : {}
                        }}
                    >
                        {option}
                    </Typography>
                ))}
            </Box>
        </div>
        <div className="p-3 content-area mt-1" style={{ marginTop: -10 }}>
            <div className="py-3 gx-0 text-white ps-3 row d-flex align-items-center justify-content-between mb-3" style={{ backgroundColor: "#ffffff" }}>
                <div className="d-flex align-items-center col-auto">
                    <div className="col-auto">
                        <TextField
                            variant="outlined"
                            autoComplete="off"
                            size="small"
                            className="text-white border border-white white-input"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon style={{ color: '#b9b5b5' }} />
                                    </InputAdornment>
                                ),
                            }}
                            placeholder="Search here"
                        />
                    </div>
                </div>
                <div className="d-flex align-items-center gap-3 col-auto mx-4">
                    <img role="button" className="" src={Maximize} alt="Maximize Icon" draggable="false" style={{ filter: "brightness(0)" }} onClick={() => _setVerifierFullscreenFlag(true)} />
                    <img role="button" className="" src={Download} alt="Download Icon" draggable="false" style={{ filter: "brightness(0)" }} onClick={exportVerifierEXCEL} />
                </div>
            </div>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ whiteSpace: "nowrap", color: "#353535", fontWeight: "700" }} align="center">S.No</TableCell>
                            <TableCell sx={{ whiteSpace: "nowrap", color: "#353535", fontWeight: "700" }} align="center">Submitted Date</TableCell>
                            <TableCell sx={{ whiteSpace: "nowrap", color: "#353535", fontWeight: "700" }} align="center">Action</TableCell>
                            <TableCell sx={{ whiteSpace: "nowrap", color: "#353535", fontWeight: "700" }} align="center">Status</TableCell>
                            <TableCell sx={{ whiteSpace: "nowrap", color: "#353535", fontWeight: "700" }} align="center">Full Name</TableCell>
                            <TableCell sx={{ whiteSpace: "nowrap", color: "#353535", fontWeight: "700" }} align="center">Gender</TableCell>
                            <TableCell sx={{ whiteSpace: "nowrap", color: "#353535", fontWeight: "700" }} align="center">Mobile No</TableCell>
                            <TableCell sx={{ whiteSpace: "nowrap", color: "#353535", fontWeight: "700" }} align="center">Email Address</TableCell>
                            <TableCell sx={{ whiteSpace: "nowrap", color: "#353535", fontWeight: "700" }} align="center">Country</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {gridLoading ? (
                            <TableRow>
                                <TableCell align="center" colSpan={9}>Loading...</TableCell>
                            </TableRow>
                        ) : filteredRows.length ? (
                            paginatedRows.map((row, index) => (
                                <TableRow key={row.id}>
                                    <TableCell sx={{ whiteSpace: "nowrap" }} align="center">{String((_page - 1) * _rowsPerPage + index + 1).padStart(2, '0')}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap" }} align="center">{row.submittedDate || ''}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap" }} align="center">
                                        <Button
                                            variant="contained"
                                            className="bg-success"
                                            style={{ borderRadius: "10px" }}
                                            onClick={() => handleViewClick(row)}
                                            type="submit"
                                        >
                                            View
                                        </Button>
                                    </TableCell>
                                    {/* <TableCell sx={{ whiteSpace: "nowrap" }} align="center">
                                        <Typography
                                            sx={{ cursor: "pointer", textDecoration: "underline" }}
                                            onClick={() => handleViewClick(row)}
                                        >
                                            {detailLoading && selectedCustomerId === String(row.id) ? "View" : "View"}
                                        </Typography>
                                    </TableCell> */}
                                    <TableCell align="center">
                                        {row?.currentStatus === "Approved" && (
                                            <Button
                                                variant="contained"
                                                className="bg-success px-4"
                                                style={{ borderRadius: "10px" }}
                                                type="submit"
                                            >
                                                Approved
                                            </Button>
                                        )}
                                        {row?.currentStatus === "Hold" && (
                                            <Button
                                                variant="contained"
                                                className="bg-info text-white px-4  text-nowrap"
                                                style={{ borderRadius: "10px" }}
                                                type="submit"
                                            >
                                                On Hold
                                            </Button>
                                        )}
                                        {row?.currentStatus === "InProgress" && (
                                            <Button
                                                variant="contained"
                                                className="bg-primary px-4  "
                                                style={{ borderRadius: "10px" }}
                                                type="submit"
                                            >
                                                InProgress
                                            </Button>
                                        )}

                                        {row?.currentStatus === "Submitted" && (
                                            <Button
                                                variant="contained"
                                                className="bg-warning px-4 text-nowrap "
                                                style={{ borderRadius: "10px" }}
                                                type="submit"
                                            >
                                                Submitted
                                            </Button>
                                        )}
                                        {row?.currentStatus === "Rejected" && (
                                            <Button
                                                variant="contained"
                                                className="bg-danger px-4 text-nowrap "
                                                style={{ borderRadius: "10px" }}
                                                type="submit"
                                            >
                                                Rejected
                                            </Button>
                                        )}
                                    </TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap" }} align="center">{row.FullName || ''}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap" }} align="center">{row.gender || ''}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap" }} align="center">{row.fieldstaffAlternativeMobile || ''}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap" }} align="center">{row.fieldStaffPrimaryEmail || ''}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap" }} align="center">{row.userAddressdet?.[0]?.country || ''}</TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell align="center" colSpan={9}>Data Not Found</TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
        <div className="d-flex justify-content-between align-items-center mt-3 pb-4">
            <TablePagination
                className="proposalPagination"
                component="div"
                rowsPerPageOptions={[5, 10, 25, 50]}
                count={totalCount}
                rowsPerPage={_rowsPerPage}
                page={_page - 1}
                SelectProps={{ inputProps: { roboto: "rows per page" }, native: true }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelDisplayedRows={() => ''}
            />

            <Pagination
                count={Math.ceil(totalCount / _rowsPerPage) || 1}
                onChange={handleChangePage1}
                page={_page}
                variant="outlined"
                size="small"
                color="primary"
                shape="rounded"
                renderItem={(item) => <PaginationItem sx={{ mx: '4px' }} {...item} />}
            />
        </div>
        <CustomDialogue
            fullScreen={true}
            title="Verifier"
            dialogueFlag={_verifierFullscreenFlag}
            borderRadius={"0px"}
            onCloseClick={() => _setVerifierFullscreenFlag(false)}
            mainContent={<div className="my-2">{getVerifierTableComponent()}</div>}
        />
    </>);
}

export default Verifier;
